module.exports = __webpack_public_path__ + "img/logonew1.a1e366bc.png";